// Copyright Robert Bosch GmbH. All rights reserved, also regarding any disposal, exploration, reproduction,
// editing, distribution, as well as in the event of applications for industrial property rights.
/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Paper } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import {
  updateBreadcrumbs,
  updateToasterConfig,
} from "../../redux/modules/app/actions";
import "./style.scss";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import httpRequest from "../../Utils/httpRequest";
import MerchantOTPDialog from "./MerchantOTPDialog";
import Loader from "../../Components/Preloader/index";
//@component
function MerchantDetails(props) {
  const [merchantKey, setmerchantKey] = useState("");
  const [merchantId, setmerchantId] = useState("");
  const [isMerch, setisMerch] = useState(false);
  const [deleteDialog, setdeleteDialog] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [OTP, setOTP] = useState("");
  const [orgId, setOrgId] = useState("");
  const [loading, setloading] = useState(false);

  useEffect(() => {
    props.dispatch(updateBreadcrumbs("payment"));
    getMerchantDetails();
    httpRequest.get(
      "createUser",
      {},
      (jsonResult) => {
        setOrgId(jsonResult.data?.org?.orgId);
      },
      errorCallbackSave,
    );
  }, []);

  useEffect(() => {
    if (OTP) {
      submitDetails(false);
    }
  }, [OTP]);

  const getMerchantDetails = () => {
    httpRequest.get(
      "getMerchantDetails",
      {},
      merchantDetailsSuccess,
      MerchantDetailsError,
      {},
    );
  };
  const merchantDetailsSuccess = (data) => {
    console.log(data);
    setmerchantId(data?.data?.merchantId ? data?.data?.merchantId : "");
    setmerchantKey(data?.data?.merchantKey ? data?.data?.merchantKey : "");
    let merchantId = data?.data?.merchantId;
    let merchantKey = data?.data?.merchantKey;
    console.log(merchantId);
    if (merchantId.length > 0 && merchantKey.length > 0) {
      setisMerch(true);
    }
  };

  const MerchantDetailsError = (err) => {
    console.log(err);
  };

  const merchantKeyHandler = (e) => {
    setmerchantKey(e.target.value);
  };

  const merchantIdHandler = (e) => {
    setmerchantId(e.target.value);
  };

  const handleMerchantDelete = () => {
    httpRequest.delete(
      "deleteMerchantMappings",
      {},
      deleteSuccess,
      (e) => {
        console.log(e);
      },
      {},
    );
  };

  const deleteSuccess = () => {
    props.dispatch(
      updateToasterConfig({
        show: true,
        message: `Merchant Details deleted Successfully`,
        color: "green",
      }),
    );
    setmerchantId("");
    setmerchantKey("");
    setisMerch(false);
    setdeleteDialog(false);
  };

  const submitDetails = (OTPTrigger) => {
    if (!OTPTrigger) {
      httpRequest.patch(
        "updateMerchantDetails",
        {
          merchantId: merchantId,
          merchantKey: merchantKey,
          otp: OTP,
          orgId: orgId,
        },
        {
          "Content-Type": "application/json",
        },
        successCallbackSave,
        errorCallbackSave,
        {},
      );
    } else {
      setloading(true);
      httpRequest.get(
        "generateEmailOTP",
        {
          "Content-Type": "application/json",
        },
        () => {
          setloading(false);
          setShowOTP(true);
        },
        errorCallbackSave,
        {
          orgId: orgId,
        },
      );
    }
  };

  const handleResend = () => {
    httpRequest.get(
      "generateEmailOTP",
      {
        "Content-Type": "application/json",
      },
      () => setShowOTP(true),
      errorCallbackSave,
      {
        orgId: orgId,
      },
    );
  };

  const successCallbackSave = (data) => {
    console.log(data);
    setOTP("");
    //setDialogOpen(false)
    setisMerch(true);
    props.dispatch(
      updateToasterConfig({
        show: true,
        message: `Merchant Details saved Successfully`,
        color: "green",
      }),
    );
  };

  const errorCallbackSave = (err) => {
    console.log(err);
    setOTP("");
    props.dispatch(
      updateToasterConfig({
        show: true,
        message: err.error_description || err.message || err.error || err,
        color: "red",
      }),
    );
    //setDialogOpen(false)
  };

  const handleSave = () => {
    submitDetails(true);
  };

  const handleVerify = (OTP) => {
    setShowOTP(false);
    setOTP(OTP);
  };

  const handleCloseOTPDialog = () => {
    setShowOTP(false);
    setOTP("");
  };

  return (
    <>
      {loading && <Loader />}
      <div className="facilitymanager-root">
        <Grid container>
          <Grid item xs={12}>
            <Paper elevation={5} className="container">
              <div className="header">
                <h2 className="heading-text">Merchant Details</h2>
              </div>
              <form className="form-field" style={{ padding: 0 }}>
                <div className="contactdetails__wrapper__container">
                  <div className="contactdetails__wrapper__container__leftside">
                    <label>Merchant Id</label>
                    <br />
                    <input
                      className="text-field-item"
                      type="password"
                      name="accountFName"
                      placeholder="Merchant Id"
                      value={merchantId?.length > 0 ? merchantId : ""}
                      onChange={merchantIdHandler}
                      disabled={isMerch == true}
                    />
                    <br />

                    <label>Merchant Key</label>
                    <br />
                    <input
                      className="text-field-item"
                      style={{
                        width: "34.5vw",
                        paddingLeft: "15px",
                      }}
                      type="password"
                      value={merchantKey?.length > 0 ? merchantKey : ""}
                      autoComplete="off"
                      name="accountFName"
                      placeholder="Merchant Key"
                      disabled={isMerch == true}
                      onChange={merchantKeyHandler}
                    />
                  </div>
                </div>
                <div className="button-section">
                  {isMerch == false ? (
                    <button
                      type="button"
                      className="form-button-submit"
                      data-testid="select-service-btn"
                      id="submitButton"
                      onClick={handleSave}
                      disabled={
                        merchantId.length === 0 || merchantKey?.length == 0
                      }
                      style={{
                        backgroundColor:
                          merchantId?.length === 0 || merchantKey?.length == 0
                            ? "#707070"
                            : undefined,
                      }}
                    >
                      Generate OTP
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="form-button-submit"
                      data-testid="select-service-btn"
                      id="submitButton"
                      onClick={() => {
                        setdeleteDialog(true);
                      }}
                    >
                      Delete merchant details
                    </button>
                  )}
                </div>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </div>     
      <Dialog
        open={deleteDialog}
        PaperProps={{
          style: {
            padding: "1% 2%",
          },
        }}
        onClose={() => {
          setdeleteDialog(false);
        }}
        aria-labelledby="create-security-admin-dialog"
      >
        <DialogTitle
          className="dialog-title"
          id="create admin dialog-header"
          style={{
            paddingBottom: "0px",
            paddingTop: "2px",
            paddingLeft: "2px",
            paddingRight: "2px",
          }}
        >
          <Grid container justify="space-between">
            <Grid item>
              <span className="dialog-create-user-text">
                Delete Merchant Details
              </span>
            </Grid>
          </Grid>
        </DialogTitle>
        <Divider />
        <DialogContent
          style={{ paddingLeft: "0px", paddingRight: "0px" }}
          className="dialog-content"
        >
          <p className="dialog-content-text">
            Do you want to delete the Merchant Details?
          </p>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <button
            type="button"
            id="confirmSubmit"
            data-testid="confirm-button"
            onClick={handleMerchantDelete}
            className="confirm-button"
          >
            Confirm
          </button>
          <button
            type="button"
            id="cancelPopup"
            data-testid="cancel-popup"
            onClick={() => {
              setdeleteDialog(false);
            }}
            className="cancel-button"
          >
            Cancel
          </button>
        </DialogActions>
      </Dialog>
      {showOTP && (
        <MerchantOTPDialog
          open={showOTP}
          handleVerify={handleVerify}
          handleResend={handleResend}
          handleClose={handleCloseOTPDialog}
        />
      )}
    </>
  );
}

export default withRouter(
  connect(() => {
    return {};
  })(MerchantDetails),
);
